import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import service from "../../services/service";
import endpoints from "../../services/endpoints";
import "./Login.css";
import { BackArw } from "../../assests/ExportImageIcon";

const NewPassword = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const email = state?.email || "";
  const [form, setForm] = useState({ new_password: "", confirm_password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      setError("Passwords do not match");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await service.post(endpoints.auth.resetpassword, {
        email,
        new_password: form.new_password,
        confirm_password: form.confirm_password,
      });
      setShowSuccess(true);
      setTimeout(() => navigate("/"), 2500);
    } catch (err) {
      setError(err.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {showSuccess && (
        <div className="success-overlay">
          <div className="success-modal">
            <div className="success-icon">✓</div>
            <h3>Password Reset Successful!</h3>
            <p>Redirecting to login...</p>
          </div>
        </div>
      )}

      <div className="login-container">
        <div className="login-card">
          <div className="backArw" onClick={() => navigate(-1)}>
            <img src={BackArw} />
          </div>
          <div className="login-title">Enter New Password</div>
          <form onSubmit={handleSubmit} className="login-form">
            <div className="form-group">
              <label>New Password</label>
              <input
                type="password"
                name="new_password"
                value={form.new_password}
                onChange={handleChange}
                placeholder="Enter new password"
                required
              />
            </div>

            <div className="form-group">
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirm_password"
                value={form.confirm_password}
                onChange={handleChange}
                placeholder="Confirm new password"
                required
              />
            </div>

            {error && <p className="login-error">{error}</p>}

            <button type="submit" className="commonOrngBtn" disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </button>
            <p className="note">Note : Password must be at least 8 characters long and include at least one uppercase letter, one lowercase letter, one number, and one special character.</p>
          </form>
        </div>
      </div>
    </>
  );
};

export default NewPassword;
